'use strict';
import React from 'react';
import flux from 'utils/flux';
import store from 'store';
import SVGInline from 'react-svg-inline';
import large_preview from './assets/large_preview.svg';
import small_preview from './assets/small_preview.svg';
import list_view from './assets/list_view.svg';

var MediaHeaderLayout = React.createClass({
    displayName: 'MediaHeaderLayout',
    getInitialState() {
        const { defaultResultView } = flux.getStore('app').getState().config.toJS();
        return {
        active: store.get('active_layout') ? store.get('active_layout') : defaultResultView || 'large_preview'
        };
    },
    setActiveLayout(active) {
        flux.getActions('media').setLayout(active);
        this.setState({
          active: store.get('active_layout')
        })
    },
    render() {
        const { active } = this.state
        return (
          <div className="headerbar__layout">
              <SVGInline className={active === 'large_preview' ? 'active layout_style' : 'layout_style'}
                         svg={large_preview}
                         onClick={() => this.setActiveLayout('large_preview')}
                         title={flux.t('large_preview')}
                         accessibilityLabel={flux.t('large_preview')}/>
              <SVGInline className={active === 'small_preview' ? 'active layout_style' : 'layout_style'}
                         svg={small_preview}
                         onClick={() => this.setActiveLayout('small_preview')}
                         title={flux.t('small_preview')}
                         accessibilityLabel={flux.t('small_preview')}/>
              <SVGInline className={active === 'list_view' ? 'active layout_style' : 'layout_style'}
                         svg={list_view}
                         onClick={() => this.setActiveLayout('list_view')}
                         title={flux.t('list_view')}
                         accessibilityLabel={flux.t('list_view')}/>
          </div>
        )
    }
})

module.exports = MediaHeaderLayout;



// WEBPACK FOOTER //
// ./app/components/headerBar/HeaderLayout.jsx